import { createContext } from 'react';
import noop from 'lodash/noop';

// =============== //
// === CREATOR === //
// =============== //

type SyncAxis = 'x' | 'y';

type Register = (node: HTMLElement, syncAxis?: SyncAxis) => void;

type Unregister = (node: HTMLElement) => void;

type ScrollContextType = {
	register: Register;
	unregister: Unregister;
};

const ScrollSynchronizerContext = createContext<ScrollContextType>({
	register: noop,
	unregister: noop,
});

export default ScrollSynchronizerContext;
export type { SyncAxis, Register, Unregister, ScrollContextType };
